var React = require('react');

function PlayInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"41","cy":"41","r":"40.5","stroke":"#021546","key":0}),React.createElement("path",{"d":"M61.6641 40.6108L62.4141 40.1778L61.6641 39.7448L32.2763 22.7777L31.5263 22.3447V23.2107L31.5263 57.1448V58.0108L32.2763 57.5778L61.6641 40.6108Z","fill":"black","stroke":"#021546","key":1})]);
}

PlayInline.defaultProps = {"width":"82","height":"82","viewBox":"0 0 82 82","fill":"none"};

module.exports = PlayInline;

PlayInline.default = PlayInline;
